// extracted by mini-css-extract-plugin
export var hd = "index-module--hd--16SpG";
export var sd = "index-module--sd--3VoM9";
export var videoContainer = "index-module--videoContainer--Lho3e";